<script>
    import Loader from '../../Loader.svelte';
    import SortableTable from '../../SortableTable.svelte';
    import {onMount} from 'svelte';
    import { addFormModal } from '../../../Forms/ModalFormManager.svelte';
    import { uuid } from '../../../Database.svelte';
    import { notifier } from "@beyonk/svelte-notifications";

    export let assessment_type_model;
    export let section;

    let fields = [
        {
            name: "name",
            field: "name",
            label: "Policy Name",
            type: "text"
        },
        {
            name: "recommendation",
            field: "recommendation",
            label: "Default Recommendation",
            type: "textarea"
        },
        {
            name: "references",
            field: "references",
            label: "Refrences",
            type: "tags"
        }
    ]

    function addPolicy() {
        addFormModal({fields}).then(savePolicy);
    }

    function editPolicy(policy) {
        addFormModal({
            fields,
            data: policy
        }).then(savePolicy);
    }

    function savePolicy(policy) {
        if (policy.id) {
            section.policies = section.policies.map(p => {
                if (p.id == policy.id) {
                    return policy
                }
                return p
            });
        } else {
            policy.id = uuid()

            section.policies = [...section.policies, policy]
        }

        saveSection();
    }

    function removePolicy(policy) {
        section.policies = section.policies.filter(p => p.id != policy.id);
    }

    function saveSection() {
        assessment_type_model.saveSection(section).then(() => {
            notifier.success("Section Saved")
        });
    }

    onMount(() => {
        if (!section.policies) {
            section.policies = []
        }
    })
</script>

<Loader loading={!section.policies}>
<div class="container is-fluid">
    <h1 class="title is-1">Policies</h1>

    <SortableTable sortFields={fields} tableData={section.policies} rowKey="id">
        <div slot="rowActions" let:row={policy}>
            <button class="button is-info" on:click={() => editPolicy(policy)}>Edit</button>
            <button class="button is-danger" on:click={() => removePolicy(policy)}>Delete</button>
        </div>
        <div slot="footerActions">
            <div class="buttons is-right">
                <button class="button is-success" on:click={addPolicy}>Add Policy</button>
            </div>
        </div>
        <div slot="filterActions">
            <div class="buttons is-right">
                <button class="button is-success" on:click={addPolicy}>Add Policy</button>
            </div>
        </div>
    </SortableTable>
</div>
</Loader>